import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, CheckCircle2 } from 'lucide-react';
import { useApp } from './store';
export function MustReads() {
  const {
    mustReads,
    acknowledgeMustRead,
    isMustReadAcknowledged
  } = useApp();
  if (mustReads.length === 0) return null;
  return <section aria-label="Must reads" data-id="element-193" data-mp="3ujyvx71ufsib">
      <div className="flex items-center justify-between mb-3" data-id="element-194" data-mp="cfxagf6ylbb8">
        <h3 className="text-lg font-serif font-bold text-navy-900" data-id="element-195" data-mp="cecgorsgxwef">
          Must Reads
        </h3>
        <Link to="/news" className="text-xs font-semibold text-gold-600 hover:text-gold-700 uppercase tracking-wide" data-id="element-196" data-mp="7gauvz3nriz9">
          View all
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-197" data-mp="h75lffnxt4qi">
        {mustReads.map((item, i) => {
        const Icon = item.icon;
        const isAcked = isMustReadAcknowledged(item.id);
        return <motion.div key={item.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className={`flex flex-col text-left bg-white rounded-xl border p-4 transition-all ${isAcked ? 'border-navy-100 opacity-75' : 'border-gold-200 shadow-sm'}`} data-id="element-198" data-mp="q94zq07khupr" data-mpi={i}>
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-3 transition-colors ${isAcked ? 'bg-navy-50 text-navy-400' : 'bg-gold-50 text-gold-600'}`} data-id="element-199" data-mp="3dsrxe9v5upr4">
                {Icon ? <Icon className="w-5 h-5" data-id="element-200" data-mp="3sjr75o7qfkca" /> : null}
              </div>
              <p className="text-[0.7rem] font-bold uppercase tracking-wide text-navy-400 mb-1" data-id="element-201" data-mp="3sllo6rfvusb3">
                {item.category}
              </p>
              <p className={`text-sm font-semibold leading-snug mb-3 flex-1 ${isAcked ? 'text-navy-600' : 'text-navy-900'}`} data-id="element-202" data-mp="1xg2w7wobbvg7">
                {item.title}
              </p>
              {isAcked ? <span className="inline-flex items-center gap-1.5 text-xs font-bold text-sage" data-id="element-203" data-mp="26ah8dqdjqpv3">
                  <CheckCircle2 className="w-4 h-4" data-id="element-204" data-mp="21hef7jcoliff" /> Acknowledged
                </span> : <button onClick={() => acknowledgeMustRead(item.id)} className="inline-flex items-center gap-1 text-xs font-bold text-gold-600 hover:text-gold-700 group" data-id="element-205" data-mp="2g5j08tz7i61d">
                  {item.due}{' '}
                  <ChevronRight className="w-3 h-3 group-hover:translate-x-0.5 transition-transform" data-id="element-206" data-mp="2l5ncg7t30els" />
                </button>}
            </motion.div>;
      })}
      </div>
    </section>;
}